<template>
    <div>
        <div class="mobile-page">
            <div class="coupon" :style="{background:configData.bgColor.color[0].item}">
                <div class="item" :style="{background:configData.themeColor.color[0].item}">
                    <div class="left">
                        <div class="num"><span>￥</span>50</div>
                        <div class="txt">满100元可用</div>
                    </div>
                    <div class="right">立<br>即<br>领<br>取</div>
                    <div class="roll up-roll" :style="{background:configData.bgColor.color[0].item}"></div>
                    <div class="roll down-roll" :style="{background:configData.bgColor.color[0].item}"></div>
                </div>
                <div class="item gary">
                    <div class="left">
                        <div class="num"><span>￥</span>50</div>
                        <div class="txt">满100元可用</div>
                    </div>
                    <div class="right">立<br>即<br>领<br>取</div>
                    <div class="roll up-roll" :style="{background:configData.bgColor.color[0].item}"></div>
                    <div class="roll down-roll" :style="{background:configData.bgColor.color[0].item}"></div>
                </div>
                <div class="item" :style="{background:configData.themeColor.color[0].item}">
                    <div class="left">
                        <div class="num"><span>￥</span>50</div>
                        <div class="txt">满100元可用</div>
                    </div>
                    <div class="right">立<br>即<br>领<br>取</div>
                    <div class="roll up-roll" :style="{background:configData.bgColor.color[0].item}"></div>
                    <div class="roll down-roll" :style="{background:configData.bgColor.color[0].item}"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "coupon",
        sort: 200,
        cname: '优惠券',
        type: 1, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconyouhuiquan1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                defaultConfig: {
                    name: "coupon",
                    cname: '优惠券',
                    tabs: [
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        bgColor: {
                            title: '背景颜色',
                            tab: 0,
                            name: 'colors',
                            default: [{
                                item: '#F8F8F8'
                            }],
                            color: [
                                {
                                    item: '#F8F8F8'
                                }

                            ]
                        },
                        themeColor: {
                            title: '主题颜色',
                            tab: 0,
                            name: 'colors',
                            default: [{
                                item: '#E93323'
                            }],
                            color: [
                                {
                                    item: '#E93323'
                                }
                            ]
                        },
                        lrEdge: {
                            title: '左右边距',
                            tab: 0,
                            name: 'slider',
                            val: 0,
                            min: 0
                        },
                        mbConfig: {
                            title: '页面间距',
                            tab: 0,
                            name: 'slider',
                            val: 0,
                            min: 0
                        },
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .couponOn {
        border-radius: 10px;
    }

    .coupon {
        display: flex;
        align-items: center;
        padding: 15px 0 15px 10px;
        background: #F8F8F8;
        overflow: hidden;

        .item {
            flex-shrink: 0;
            position: relative;
            display: flex;
            width: 152px;
            height: 76px;
            background: rgba(233, 51, 35, 1);
            color: #fff;
            border-radius: 5px;
            margin-right: 10px;

            &.gary {
                background: #D8D8D8
            }

            .left {
                width: 120px;
                height: 76px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .num {
                    font-size: 24px;
                    font-weight: bold;

                    span {
                        font-size: 12px;
                    }
                }

                .txt {
                    font-size: 12px;
                }
            }

            .right {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                border-left: 1px dashed #fff;
            }

            .roll {
                position: absolute;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: #F8F8F8;

                &.up-roll {
                    right: 26px;
                    top: -5px;
                }

                &.down-roll {
                    right: 26px;
                    bottom: -5px;
                }
            }
        }
    }
</style>
